import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss']
})
export class AlertBoxComponent implements OnInit {

  @Input() heading: string;

  @Input() message: string;

  @Input() type: string;

  constructor() { }

  ngOnInit(): void {
  }

}
